<template>
  <div>
    <!-- 搜索 -->
    <div class="search-container">
      <div class="left">
        <!-- 手机号 -->
        <el-input size="small" clearable v-model="searchParams.mobile" placeholder="请输入手机号"></el-input>
        <!-- APPID -->
        <el-input size="small" clearable v-model="searchParams.appid" placeholder="请输入AppId"></el-input>
        <!-- UID -->
        <el-input size="small" clearable v-model="searchParams.uid" placeholder="请输入UID"></el-input>
        <!-- SDK版本 -->
        <el-input size="small" clearable v-model="searchParams.sdkVer" placeholder="请输入SDK版本"></el-input>
        <!-- APK版本 -->
        <el-input size="small" clearable v-model="searchParams.apkVer" placeholder="请输入APK版本"></el-input>
        <!-- 机型 -->
        <el-input size="small" clearable v-model="searchParams.model" placeholder="请输入机型"></el-input>
        <!-- 厂商 -->
        <el-input size="small" clearable v-model="searchParams.facturer" placeholder="请输入厂商"></el-input>
        <!-- 时间 -->
        <el-date-picker size="small" clearable v-model="searchParams.createTime" :picker-options="pickerOptions"
          type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间"
          value-format="timestamp">
        </el-date-picker>
      </div>
      <div class="right">
        <el-button v-auth="'PLUGIN_MANAGE_PLUGIN_DISTRIBUTION_SEARCH'" size="small" type="primary"
          @click="search">查询</el-button>

      </div>
    </div>
    <el-dialog title="该手机号下绑定有多个UID，请指定UID进行查询" :visible.sync="dialog.visible" width="30%" append-to-body
      :modal-append-to-body="false" @closed="closed" :close-on-click-modal="true">

      <el-select style="width: 250px;" v-model="searchParams.uid" placeholder="请选择UID" size="small" clearable>
        <el-option v-for="item in uidList" :key="item" :label="item" :value="item"></el-option>
      </el-select>

      <span slot="footer" style="flex-end">
        <el-button size="small" @click="hide">取 消</el-button>
        <el-button size="small" type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getPluginDistribution, getUidByMobile } from '@/api/pluginManage/pluginDistribution';
import Message from '@/components/Message';
import _ from 'lodash';
export default {
  name: "WebSaaSSearch",
  inject: ["searchParams", 'list'],

  data() {
    return {
      /** 对话框 */
      dialog: {
        visible: false,

      },
      /** 多uid选择列表 */
      uidList: [],
      pickerOptions: {
        // 选中日期时触发限制逻辑
        onPick: this.handlePick,
      },

    };
  },
  methods: {

    open() {
      this.dialog.visible = true;
    },
    hide() {
      this.dialog.visible = false;
      this.searchParams.uid = ''
      this.uidList = []
    },
    confirm() {
      this.dialog.visible = false;
      this.uidList = []
    },
    handlePick({ maxDate, minDate }) {
      if (minDate && maxDate) {
        // 创建起始日期的副本
        const sixMonthsLater = new Date(minDate);
        // 将副本日期加6个月
        sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6);

        // 如果结束日期超过加6个月后的日期，则超出范围
        if (maxDate > sixMonthsLater) {
          Message.error("选择的时间段不能超过六个月");
          // 超出范围则清空选择
          this.searchParams.createTime = null;
        }
      }
    },
    async search() {
      console.log("🚀 ~ search ~ searchParams:", this.searchParams)
      if (this.searchParams.mobile && !this.searchParams.uid) {
        const { data } = await getUidByMobile({ mobile: this.searchParams.mobile })
        /** 如果数组存在，去重 */
        if (data.data && data.data.length > 0) {
          this.uidList = _.uniq(data.data)
          Message.info('该手机号下绑定有多个UID，请指定UID进行查询')
          this.dialog.visible = true
        }
        console.log("🚀 ~ search ~ res:", data)
      } else if (!this.searchParams.createTime) {
        Message.error('请选择时间范围')
      } else {
        /** 手机号和uid都有填写 那么就执行搜索 */
        const params = { ...this.searchParams }
        params.startTime = this.searchParams.createTime[0] ? this.searchParams.createTime[0] : 0
        params.endTime = this.searchParams.createTime[1] ? this.searchParams.createTime[1] : 0
        delete params.createTime
        const { data } = await getPluginDistribution(params)
        this.list.value = [...data.data]
        console.log("🚀 ~ search ~ data:", data)

      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;


  .left {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    ::v-deep .el-input {
      width: 200px;
      margin-right: 10px;
    }
  }

  .right {
    display: flex;
  }
}
</style>
